export default __webpack_public_path__ + "static/media/user-management.5bf4c677.svg";